<!-- !! Attention: Student account會共用呢個page，留意返啲permission !! -->
<template>
  <v-container fluid>
    <PageHeaderSlot :showBackButton="!isStudent">
      <template slot="top-right-slot" v-if="$validate.DataValid(id) && !isStudent">
        <!-- 查看電子簽名 -->
        <FormButton
          v-if="enableSign && $validate.DataValid(formData.sign)"
          text="viewEleSign"
          class="ml-2 mb-1"
          @click="viewImg(`${$mediaPath}${formData.sign}`)"
        />
        <!-- 複製學生網址 -->
        <FormButton v-if="!gDisableStudentAccount" text="copyStudentUrl" class="ml-2 mb-1" @click="copyStudentUrl()" />
        <!-- 付款紀錄 -->
        <FormButton
          v-if="canViewOrder"
          text="paymentRecord"
          class="ml-2 mb-1"
          :to="{ name: 'OrderList', params: { sid: id } }"
        />
        <!-- 上堂紀錄 -->
        <FormButton
          v-if="canViewAttendance"
          text="attendanceRecord"
          class="ml-2 mb-1"
          :to="{ name: 'StudentAttendance', params: { id: id } }"
        />
        <!-- 重新入學 -->
        <FormButton
          v-if="canQuitAndRemission && formData.status === 'inactive'"
          text="remission"
          class="ml-2 mb-1"
          @click="handleStudentRemission()"
        />
        <!-- 學生退學 -->
        <FormButton
          v-else-if="canQuitAndRemission && formData.status !== 'inactive'"
          text="quit"
          color="error"
          class="ml-2 mb-1"
          @click="handleStudentQuit()"
        />
        <template v-if="!isAppMode(['T01'])">
          <!-- 限制登入 -->
          <FormButton
            v-if="canBlock && !formData.login_block"
            text="blockLogin"
            color="error"
            class="ml-2"
            @click="handleBlockStudent()"
          />
          <!-- 解除登入限制 -->
          <FormButton
            v-else-if="canBlock && formData.login_block"
            text="removeLoginBlock"
            class="ml-2"
            @click="handleRemoveBlock()"
          />
        </template>
      </template>
    </PageHeaderSlot>

    <v-row class="mb-0 align-stretch" v-if="id !== null">
      <v-col cols="12" sm="6" md="4" lg="3" v-if="enablePoints && canViewPointsRecord">
        <v-card height="100%">
          <v-card-text>
            <div class="d-flex align-start justify-space-between">
              <label class="colorBlack--text text-body-2 d-block mb-2">{{ $t('pointsName') }}</label>
              <v-btn
                depressed
                text
                color="primary"
                class="pa-0"
                small
                :ripple="false"
                style="height: auto !important;"
                :to="
                  isStudent
                    ? { name: 'StudentUserPoints', params: { username: formData.username } }
                    : { name: 'StudentPoints', params: { id: id } }
                "
              >
                {{ $t('viewRecord') }}
              </v-btn>
            </div>
            <div class="colorBlack--text font-weight-medium text-h3">{{ pointsCanUse }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" v-if="gEnableMonthPass && canEdit && existMonthPassDates.length > 0">
        <v-card height="100%">
          <v-card-text>
            <div class="d-flex align-start justify-space-between">
              <label class="colorBlack--text text-body-2 d-block mb-2">{{ $t('monthPass') }}</label>
              <v-btn
                v-if="!isStudent"
                depressed
                text
                color="primary"
                :ripple="false"
                class="pa-0"
                small
                style="height: auto !important;"
                @click.prevent="openAssignMonthPass()"
              >
                {{ $t('applyCourse') }}
              </v-btn>
            </div>
            <div class="colorBlack--text font-weight-medium text-h6" v-for="date in existMonthPass">
              {{ formatMonthPassDate(date.start_date) }} - {{ formatMonthPassDate(date.end_date) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-form ref="dataForm" @submit.prevent="">
      <v-card class="mb-4">
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormUploader
                uploadText="uploadAvatar"
                fileInputKey="upload_avatar"
                :files.sync="formData.avatar_list"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                single
                enablePreview
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T17', 'T27']) && initFormData.student_code">
              <qrcode-vue :value="initFormData.student_code" :size="150" level="H" render-as="canvas" id="qrCanvas" />
              <v-btn small outlined @click.prevent="downloadQrCode()">{{ $t('table.download') }}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="studentCode"
                placeholder="studentCode"
                :fieldValue.sync="formData.student_code"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
                :disabled="isStudent"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="!gDisableStudentCenter">
              <FormSelect
                v-if="gEnableStudentMultiCenter"
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.schools"
                :options="tutorSchoolOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
                :disabled="isStudent"
                isMultiple
              />
              <FormSelect
                v-else
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.school_id"
                :options="tutorSchoolOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
                :disabled="isStudent"
              />
            </v-col>
            <template v-for="item in topFieldList">
              <v-col v-if="showField(item.key)" :class="getFieldCol(item.key)" :key="item.key">
                <FormSearchSelect
                  v-if="item.key === 'upline_student_code'"
                  :label="item.label"
                  :placeholder="item.label"
                  :fieldValue.sync="formData[item.key]"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                  :disabled="isStudent && item.disable_student"
                  :required="item.required"
                  :enableClear="!item.required"
                  searchPlaceholder="searchStudentCode"
                  :options="uplineStudentOptions"
                  :searching="studentSearching"
                  @click-search="searchUplineStudents($event)"
                >
                  <template slot="append-inner">
                    <v-btn
                      v-if="$validate.DataValid(formData[item.key])"
                      icon
                      text
                      depressed
                      x-small
                      @click.prevent="gfCopyText(formData[item.key])"
                    >
                      <v-icon class="fi fi-rr-copy" size="15" color="primary"></v-icon>
                    </v-btn>
                  </template>
                </FormSearchSelect>
                <Field
                  v-else
                  :item="item"
                  :fieldValue.sync="formData[item.key]"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :canEdit="canEdit"
                  :isStudent="isStudent"
                  :selectOptions="gfGetOptionsByKey(item.key)"
                  @select-changed="handleFieldChanged(item.key, $event)"
                  @date-changed="handleFieldDateChanged(item.key, $event)"
                  @input="handleFieldInput(item.key, $event)"
                />
              </v-col>
            </template>
          </v-row>
          <v-row class="ma-0" v-if="botFieldList.length || fieldFormList.length">
            <template v-for="item in botFieldList">
              <v-col v-if="showField(item.key)" :class="getFieldCol(item.key)" :key="item.key">
                <template v-if="item.key === 'wish_lesson'">
                  <label class="input-label">{{ $t('applyCourse') }}</label>
                  <div class="d-flex align-center">
                    {{ wishLesson || '-' }}
                    <v-btn
                      v-if="$validate.DataValid(formData.wish_lesson) && formData.wish_lesson > -1 && canViewLesson"
                      icon
                      text
                      depressed
                      x-small
                      :to="{ name: 'ClassDetails', params: { id: formData.wish_lesson } }"
                    >
                      <v-icon class="fi fi-rr-eye mr-1" size="12" color="primary"></v-icon>
                    </v-btn>
                  </div>
                </template>
                <Field
                  v-else
                  :item="item"
                  :fieldValue.sync="formData[item.key]"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :canEdit="canEdit"
                  :isStudent="isStudent"
                  :selectOptions="gfGetOptionsByKey(item.key)"
                  @select-changed="handleFieldChanged(item.key, $event)"
                  @date-changed="handleFieldDateChanged(item.key, $event)"
                  @input="handleFieldInput(item.key, $event)"
                />
              </v-col>
              <v-col :class="getFieldCol('age')" v-if="!isAppMode(['T27']) && item.key === 'birthday'">
                <FormInput
                  readonly
                  label="age"
                  placeholder="age"
                  :fieldValue.sync="formData.age"
                  isIntegerOnly
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                />
              </v-col>
            </template>

            <v-col v-for="item in fieldFormList" :class="getFieldCol(item.field_key)">
              <Field
                :key="item.field_key"
                :item="item"
                :fieldValue.sync="formData[item.key]"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :canEdit="canEdit"
                :isStudent="isStudent"
                :selectOptions="item.options"
                @select-changed="handleFieldChanged(item.key, $event)"
                @input="handleFieldInput(item.key, $event)"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0" v-if="!gDisableStudentAccount">
            <v-col
              cols="6"
              :md="$validate.DataValid(id) && canEdit ? '5' : '4'"
              :lg="$validate.DataValid(id) && canEdit ? '4' : '3'"
              class="pb-0"
            >
              <FormInput
                label="accountName"
                placeholder="accountName"
                :fieldValue.sync="formData.username"
                :required="usernameRequired"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              >
                <template slot="append-outer" v-if="$validate.DataValid(id) && canEdit">
                  <FormButton text="resetPassword" @click="handleChangePassword()" />
                </template>
              </FormInput>
            </v-col>
            <v-col cols="6" md="4" lg="3" class="pb-0" v-if="!$validate.DataValid(id)">
              <FormInput
                label="password"
                type="password"
                :fieldValue.sync="formData.password"
                :required="!$validate.DataValid(id)"
                showPwView
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                @input-value="isNewPasswordEdit = true"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <small class="text-caption">{{ $t('createStudentAccountHint') }}</small>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pa-0" v-if="isAppMode(['T49'])">
          <v-row class="ma-0 px-2">
            <v-col cols="12">
              <h2 class="colorBlack--text">{{ $t('referee') }}</h2>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="ma-0 px-2 pt-3">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="refereeName"
                placeholder="refereeName"
                :fieldValue.sync="formData.referee_name"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="canViewPhone">
              <FormInput
                type="tel"
                label="phone"
                placeholder="phone"
                :fieldValue.sync="formData.referee_phone"
                isIntegerOnly
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              >
                <template slot="append-outer" v-if="!isStudent">
                  <WhatsappButton :phone="formData.referee_phone" />
                </template>
              </FormInput>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="pa-0" v-if="!isAppMode(['T27']) && !(isAppMode(['T49']) && userType === 'tutor')">
          <v-row class="ma-0 px-2">
            <v-col cols="12">
              <h2 class="colorBlack--text">{{ $t('contactPerson') }}</h2>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row class="ma-0 px-2 pt-3">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                :label="
                  $t('contactPersonName', { number: 1, relationship: $t(isAppMode(['T21']) ? 'parent' : 'father') })
                "
                :placeholder="
                  $t('contactPersonName', { number: 1, relationship: $t(isAppMode(['T21']) ? 'parent' : 'father') })
                "
                :fieldValue.sync="formData.contact_person_1_name"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="canViewPhone">
              <FormInput
                type="tel"
                :label="
                  $t('contactPersonPhone', { number: 1, relationship: $t(isAppMode(['T21']) ? 'parent' : 'father') })
                "
                :placeholder="
                  $t('contactPersonPhone', { number: 1, relationship: $t(isAppMode(['T21']) ? 'parent' : 'father') })
                "
                :fieldValue.sync="formData.contact_person_1_phone"
                isIntegerOnly
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              >
                <template slot="append-outer" v-if="!isStudent">
                  <WhatsappButton :phone="formData.contact_person_1_phone" />
                </template>
              </FormInput>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T03'])">
              <FormInput
                type="email"
                :label="$t('contactPersonEmail', { number: 1, relationship: $t('father') })"
                :placeholder="$t('contactPersonEmail', { number: 1, relationship: $t('father') })"
                :fieldValue.sync="formData.contact_person_1_email"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T46'])">
              <FormInput
                :label="$t('contactPersonRelationship', { number: 1 })"
                :placeholder="$t('contactPersonRelationship', { number: 1 })"
                :fieldValue.sync="formData.contact_person_1_relationship"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="d-none d-sm-block d-md-none d-lg-block"
              v-if="isAppMode(['T03', 'T46'])"
            ></v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                :label="
                  $t('contactPersonName', { number: 2, relationship: $t(isAppMode(['T21']) ? 'emergency' : 'mother') })
                "
                :placeholder="
                  $t('contactPersonName', { number: 2, relationship: $t(isAppMode(['T21']) ? 'emergency' : 'mother') })
                "
                :fieldValue.sync="formData.contact_person_2_name"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="canViewPhone">
              <FormInput
                type="tel"
                :label="
                  $t('contactPersonPhone', { number: 2, relationship: $t(isAppMode(['T21']) ? 'emergency' : 'mother') })
                "
                :placeholder="
                  $t('contactPersonPhone', { number: 2, relationship: $t(isAppMode(['T21']) ? 'emergency' : 'mother') })
                "
                :fieldValue.sync="formData.contact_person_2_phone"
                isIntegerOnly
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              >
                <template slot="append-outer" v-if="!isStudent">
                  <WhatsappButton :phone="formData.contact_person_2_phone" />
                </template>
              </FormInput>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T03'])">
              <FormInput
                type="email"
                :label="$t('contactPersonEmail', { number: 2, relationship: $t('mother') })"
                :placeholder="$t('contactPersonEmail', { number: 2, relationship: $t('mother') })"
                :fieldValue.sync="formData.contact_person_2_email"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['T46'])">
              <FormInput
                :label="$t('contactPersonRelationship', { number: 2 })"
                :placeholder="$t('contactPersonRelationship', { number: 2 })"
                :fieldValue.sync="formData.contact_person_2_relationship"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="d-none d-sm-block d-md-none d-lg-block"
              v-if="isAppMode(['T03', 'T46'])"
            ></v-col>

            <template v-if="isAppMode(['T03'])">
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormInput
                  :label="$t('contactPersonName', { number: 3, relationship: $t('emergency') })"
                  :placeholder="$t('contactPersonName', { number: 3, relationship: $t('emergency') })"
                  :fieldValue.sync="formData.contact_person_3_name"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3" v-if="canViewPhone">
                <FormInput
                  type="tel"
                  :label="$t('contactPersonPhone', { number: 3, relationship: $t('emergency') })"
                  :placeholder="$t('contactPersonPhone', { number: 3, relationship: $t('emergency') })"
                  :fieldValue.sync="formData.contact_person_3_phone"
                  isIntegerOnly
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                >
                  <template slot="append-outer" v-if="!isStudent">
                    <WhatsappButton :phone="formData.contact_person_3_phone" />
                  </template>
                </FormInput>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormInput
                  type="email"
                  :label="$t('contactPersonEmail', { number: 3, relationship: $t('emergency') })"
                  :placeholder="$t('contactPersonEmail', { number: 3, relationship: $t('emergency') })"
                  :fieldValue.sync="formData.contact_person_3_email"
                  :dispatchUpdateOnChange="dispatchUpdateOnChange"
                  :readonly="!canEdit"
                />
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>

    <div class="d-flex align-center mt-4" v-if="canEdit">
      <FormButton @click="save()" />
      <FormButton
        v-if="$validate.DataValid(id) && canDelete"
        text="delete"
        class="ml-4"
        outlined
        color="error"
        @click="handleDeleteStudent()"
      />
    </div>

    <!-- [T27] 組員 -->
    <Datatable
      v-if="isAppMode(['T27']) && $validate.DataValid(id)"
      class="mt-6"
      tableName="teamMember"
      :tableData="teamMemberTableData"
      :tableHeaders="teamMemberTableHeaders"
      disablePagination
      @delete-clicked="handleDeleteTeamMember($event)"
    >
      <template slot="append-toolbar-left" v-if="canEdit && !isStudent">
        <FormButton text="add" class="ml-4 my-2" @click="handleAddTeamMember()" isAdd />
      </template>
      <template v-slot:[`item.student_name`]="{ item }">
        <div class="d-flex align-center">
          <div style="white-space: nowrap;">{{ item.student_name }}</div>
          <v-btn v-if="!isStudent" icon depressed x-small :disabled="!item.active" @click.prevent="navSibling(item.id)">
            <v-icon class="fi fi-rr-eye" size="12" color="primary"></v-icon>
          </v-btn>
        </div>
      </template>
    </Datatable>

    <!-- 兄弟姊妹 -->
    <Datatable
      v-if="gEnableSibling && $validate.DataValid(id)"
      class="mt-6"
      tableName="siblings"
      :tableData="siblingTableData"
      :tableHeaders="siblingTableHeaders"
      disablePagination
      @edit-clicked="handleAddSibling($event)"
      @delete-clicked="handleDeleteSibling($event)"
    >
      <template slot="append-toolbar-left" v-if="canEdit && !isStudent">
        <FormButton text="add" class="ml-4 my-2" @click="handleAddSibling()" isAdd />
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <div class="d-flex align-center">
          <div style="white-space: nowrap;">{{ item.name }}</div>
          <v-btn
            v-if="!isStudent"
            icon
            text
            depressed
            x-small
            :disabled="!item.active"
            @click.prevent="navSibling(item.id)"
          >
            <v-icon class="fi fi-rr-eye mr-1" size="12" color="primary"></v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.relationship`]="{ item }">
        <span v-if="item.relationship">{{ $t('siblingOptions.' + item.relationship) }}</span>
      </template>
    </Datatable>

    <!-- 學生成績 -->
    <Datatable
      v-if="$validate.DataValid(id) && !disableScore"
      class="mt-6"
      tableName="performance"
      :isLoading="scoreTableLoading"
      :tableData="scoreTableData"
      :tableHeaders="performanceTableHeaders"
      disablePagination
      @edit-clicked="handleAddPerformance($event)"
      @delete-clicked="handleDeletePerformance($event)"
    >
      <template slot="append-toolbar-left" v-if="canEdit && !isStudent">
        <FormButton
          :text="isAppMode(['T01']) && scoreTableData.length ? 'updatePerformance' : 'createPerformance'"
          isAdd
          class="ml-4 my-2"
          @click="handleAddPerformance()"
        />
      </template>

      <template v-slot:[`item.semester`]="{ item }">
        <span v-if="item.semester">{{ $t('semesterOption.' + item.semester) }}</span>
      </template>

      <template v-slot:[`item.subject`]="{ item }">
        <span v-if="item.subject">{{ $t('subjectOption.' + item.subject) }}</span>
      </template>

      <template v-slot:[`item.score`]="{ item }">
        <div class="d-flex" v-if="isAppMode(['T01']) && item.score">
          <div :class="`belt-color ${item.score} mr-2`"></div>
          <span>{{ $t('beltOptions.' + item.score) }}</span>
        </div>
        <span v-else>{{ item.score }}</span>
      </template>

      <template v-slot:[`item.file`]="{ item }">
        <v-btn @click.prevent="previewFile(item.file)" text depressed small color="primary">{{ item.file }}</v-btn>
      </template>

      <template v-slot:[`item.show_public`]="{ item }">
        <span v-if="item.show_public === false">{{ $t('false') }}</span>
        <span v-else>{{ $t('true') }}</span>
      </template>
    </Datatable>

    <!-- [T21] 學生消息 -->
    <Datatable
      v-if="isAppMode(['T21'])"
      class="mt-6"
      tableName="studentNews"
      :tableData="studentNewsTableData"
      :tableHeaders="studentNewsHeaders"
      disablePagination
      @edit-clicked="handleAddStudentNews($event)"
      @delete-clicked="handleDeleteStudentNews($event)"
    >
      <template slot="append-toolbar-left" v-if="canEdit && !isStudent">
        <FormButton text="add" class="ml-4 my-2" @click="handleAddStudentNews()" isAdd />
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <span v-if="item.date">{{ item.date.substring(0, 10) }} {{ item.date.substring(11, 16) }}</span>
      </template>
    </Datatable>

    <!-- Log Record -->
    <LogTable
      v-if="$validate.DataValid(id) && canViewLog"
      ref="logTableRef"
      class="mt-6"
      :loading="logLoading"
      :tableData="logTableData"
      :total="logTableTotal"
      @options-update="getLogData()"
    />

    <!-- Modal: 重設密碼 -->
    <FormDialog
      v-if="$validate.DataValid(id)"
      title="resetPassword"
      btnAlign="center"
      ref="passwordFormDialog"
      formRef="passwordForm"
      :maxWidth="500"
    >
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="newPassword" type="password" :fieldValue.sync="newPassword" required />
        </v-col>
        <v-col cols="12">
          <FormInput
            label="confirmNewPassword"
            type="password"
            :fieldValue.sync="confirmPassword"
            required
            :customRules="[
              v => {
                return (
                  !$validate.DataValid(v) ||
                  ($validate.DataValid(v) && v === newPassword) ||
                  $t('message.passwordNotMatch')
                )
              },
            ]"
          />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 新增成績 -->
    <FormDialog
      v-if="$validate.DataValid(id) && !disableScore && !isStudent"
      :title="checkIsEditPerformance() ? 'editPerformance' : 'createPerformance'"
      ref="performanceDialog"
      formRef="performanceForm"
    >
      <v-row class="ma-0" v-if="isAppMode(['T01'])">
        <v-col cols="12" md="6">
          <FormDatePicker
            label="updateTime"
            placeholder="updateTime"
            :dateValue.sync="performanceFormData.update_date"
            required
            disabledActionButtons
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormSelect
            label="belt"
            placeholder="selectBelt"
            :fieldValue.sync="performanceFormData.score"
            :options="scoreOptions"
            required
          />
        </v-col>
      </v-row>
      <v-row class="ma-0" v-else>
        <v-col cols="12" md="6">
          <FormSelect
            label="grade"
            placeholder="selectGrade"
            :fieldValue.sync="performanceFormData.grade"
            :options="gradeOptions"
            required
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormSelect
            label="semester"
            placeholder="selectSemester"
            :fieldValue.sync="performanceFormData.semester"
            :options="semesterOptions"
            required
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormSelect
            label="subject"
            placeholder="selectSubject"
            :fieldValue.sync="performanceFormData.subject"
            :options="subjectOptions"
            required
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormInput
            label="examName"
            placeholder="examName"
            :fieldValue.sync="performanceFormData.exam_name"
            required
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormInput label="score" placeholder="score" :fieldValue.sync="performanceFormData.score" required />
        </v-col>
        <template>
          <v-col cols="12" md="6">
            <FormSelect
              label="studentCanViewScore"
              :fieldValue.sync="performanceFormData.show_public"
              :options="yesNoOptions"
              required
            />
          </v-col>
          <v-col cols="12" md="6">
            <FormUploader
              uploadText="uploadDoc"
              fileInputKey="upload_score_file"
              :files.sync="performanceFormData.file_list"
              :acceptFormat="['image', 'pdf']"
              dispatchUpdateOnChange
              single
            />
          </v-col>
        </template>
      </v-row>
    </FormDialog>

    <!-- Modal: 學生消息 -->
    <FormDialog
      v-if="isAppMode(['T21']) && !isStudent"
      title="studentNews"
      ref="studentNewsDialog"
      formRef="studentNewsForm"
      :maxWidth="600"
    >
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="content" placeholder="content" :fieldValue.sync="studentNewsData.content" required />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 兄弟姊妹 -->
    <FormDialog
      v-if="gEnableSibling && $validate.DataValid(id) && !isStudent"
      title="siblings"
      ref="siblingFormDialog"
      formRef="siblingForm"
      :maxWidth="500"
    >
      <v-row class="ma-0">
        <v-col cols="12">
          <FormSearchSelect
            label="student"
            :fieldValue.sync="siblingData.student_id"
            :options="studentOptions"
            searchPlaceholder="searchStudentData"
            :searching="studentSearching"
            @click-search="searchStudents($event)"
            required
            @onselect="onSiblingStudentChanged($event)"
          />
        </v-col>
        <v-col cols="12">
          <FormSelect
            label="relationship"
            placeholder="relationship"
            :fieldValue.sync="siblingData.relationship"
            :options="siblingOptions"
            required
            :readonly="!$validate.DataValid(siblingData.student_id) || siblingData.student_id < 0"
          />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 組員 -->
    <FormDialog
      v-if="isAppMode(['T27']) && $validate.DataValid(id) && !isStudent"
      title="teamMember"
      ref="teamMemberFormDialog"
      formRef="teamMemberForm"
      :maxWidth="500"
    >
      <v-row class="ma-0">
        <v-col cols="12">
          <FormSearchSelect
            label="student"
            :fieldValue.sync="teamMemberData.student_id"
            :options="studentOptions"
            searchPlaceholder="searchStudentData"
            :searching="studentSearching"
            @click-search="searchStudents($event)"
            required
          />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 報讀課程 -->
    <AssignLessonDialog
      v-if="gEnableMonthPass && !isStudent && $validate.DataValid(id)"
      ref="addCourseDialog"
      :loading="isSearching"
      :courseNameOptions="courseNameOptions"
      :courseNameSearching="courseNameSearching"
      :tutorOptions="tutorOptions"
      :disableGrade="disableCourseGrade"
      filterLessonType="singleDate"
      :filterCourseName.sync="addCourseFilter.keyword"
      :filterDates.sync="addCourseFilter.dateRange"
      :filterTutor.sync="addCourseFilter.tutor"
      :filterGrade.sync="addCourseFilter.grade"
      :filterPage.sync="addCourseFilter.page"
      :filterLimit.sync="addCourseFilter.limit"
      :filterCenter="userSelectedSchool"
      :tableData="addCourseFilter.tableData"
      :tableHeaders="addCourseTableHeaders"
      :tableTotal="addCourseFilter.total"
      :tempSelectedLesson="tempSelectedLesson"
      @filter-update="onCourseFilterChange()"
      @options-update="searchCourses()"
      @close="handleAddCourseActionClick($event)"
    >
      <template slot="extra">
        <v-row class="ma-0 px-4">
          <v-col cols="12"><v-divider></v-divider></v-col>

          <v-col cols="12" class="mt-6">
            <label class="input-label">{{ $t('applyRuleType') }}</label>

            <v-radio-group
              name="applyRuleType"
              v-model="addCourseFilter.lessonRule"
              row
              hide-details
              class="ma-0"
              @change="onSelectLessonRuleChanged()"
              :readonly="isSearching"
            >
              <v-radio :label="$t('autoGrabLesson')" value="auto"></v-radio>
              <v-radio :label="$t('customLesson')" value="manually"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`actionSelectCourse`]="{ item }">
        <div class="colorGrey--text pointer-none" v-if="item.applied">{{ $t('lessonStatus.applied') }}</div>
        <v-btn
          v-else
          :loading="$store.getters.isLoading"
          depressed
          text
          :color="isItemSelected(item.id) ? 'red' : 'primary'"
          :ripple="false"
          class="pa-0"
          :class="{ 'pointer-none': $store.getters.isLoading }"
          style="min-width: unset !important;"
          @click="handleAssignLessonSelected(item.id)"
          :disabled="item.disabled"
        >
          {{ $t(isItemSelected(item.id) ? 'cancel' : 'apply') }}
        </v-btn>
      </template>
    </AssignLessonDialog>

    <!-- Alert: 轉到該分校頁面 -->
    <FormDialog ref="confirmChangeCenterMulti" formRef="selectCenterForm" enableCancel :maxWidth="500">
      <div>{{ $t('message.confirmChangeCenter1', { name: this.changeCenterAlert.studentName }) }}</div>
      <v-radio-group v-model="changeCenterAlert.schoolId" class="ma-0" :rules="[v => this.$validate.required(v)]">
        <v-radio
          v-for="item in changeCenterAlert.centerOptions"
          :label="item.text"
          :value="item.value"
          :key="item.value"
        ></v-radio>
      </v-radio-group>
      <div>{{ $t('message.confirmChangeCenter2') }}</div>
    </FormDialog>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import FormDialog from '@/components/FormDialog.vue'
import QrcodeVue from 'qrcode.vue'
import DialogLayout from '@/components/layout/DialogLayout.vue'
import WhatsappButton from '@/components/WhatsappButton.vue'
import FormSearchSelect from '@/components/formField/FormSearchSelect.vue'
import FormUploader from '@/components/formField/FormUploader.vue'
import AssignLessonDialog from '../PayTuition/components/AssignLessonDialog.vue'
import fields from './components/fields'
import Field from './components/Field.vue'
import LogTable from '@/components/LogTable.vue'

export default {
  name: 'StudentDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
    FormInput,
    FormSelect,
    FormDatePicker,
    FormDialog,
    QrcodeVue,
    DialogLayout,
    WhatsappButton,
    FormSearchSelect,
    FormUploader,
    AssignLessonDialog,
    Field,
    LogTable,
  },
  computed: {
    confirmRef() {
      return this.getConfirmDialogRef()
    },
    routeId() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
    performanceTableHeaders() {
      const vm = this
      let headers = []
      if (this.isAppMode(['T01'])) {
        headers = [
          { value: 'create_date', text: vm.$t('updateTime'), width: 130 },
          { value: 'score', text: vm.$t('belt') },
        ]
      } else {
        headers = [
          { value: 'create_date', text: vm.$t('createdDate'), width: 130 },
          { value: 'grade', text: vm.$t('grade') },
          { value: 'semester', text: vm.$t('semester') },
          { value: 'subject', text: vm.$t('subject') },
          { value: 'exam_name', text: vm.$t('examName') },
          { value: 'score', text: vm.$t('score') },
        ]

        headers.push({ value: 'file', text: '' })
        if (!this.isStudent) {
          headers.push({ value: 'show_public', text: vm.$t('studentCanViewScore') })
        }
      }

      if (this.canEdit && !this.isStudent) {
        headers.push({ value: 'minActionEditAndDelete', text: '', align: 'end' })
      }

      return headers
    },
    studentNewsHeaders() {
      const vm = this
      let headers = [
        { value: 'date', text: vm.$t('createdDate'), width: 130 },
        { value: 'content', text: vm.$t('content') },
      ]
      if (this.canEdit && !this.isStudent) {
        headers.push({ value: 'minActionDelete', text: '', align: 'end' })
      }
      return headers
    },
    siblingTableHeaders() {
      const vm = this
      let headers = [
        { value: 'name', text: vm.$t('name') },
        { value: 'relationship', text: vm.$t('relationship') },
      ]
      if (this.canEdit && !this.isStudent) {
        headers.push({ value: 'minActionEditAndDelete', text: '', align: 'end' })
      }
      return headers
    },
    teamMemberTableHeaders() {
      const vm = this
      let headers = [
        { value: 'student_code', text: vm.$t('studentCode') },
        { value: 'student_name', text: vm.$t('memberName') },
      ]
      if (this.canEdit && !this.isStudent) {
        headers.push({ value: 'minActionDelete', text: '', align: 'end' })
      }
      return headers
    },
    isStudent() {
      return this.userType === 'student'
    },
    gradeOptions() {
      return this.$store.getters.gradeOptions
    },
    addCourseTableHeaders() {
      const vm = this
      let headers = [
        { value: 'course_name', text: vm.$t('purchaseItem') },
        { value: 'full_date', text: vm.$t('date'), hasWeekday: true },
        { value: 'timeslot', text: vm.$t('time') },
      ]

      if (!this.disableCourseGrade) {
        headers.push({ value: 'grade', text: vm.$t('grade') })
      }

      headers = [
        ...headers,
        { value: 'tutor', text: vm.$t('tutor') },
        { value: 'current_per_max_student_num', text: vm.$t('personCount') },
        { value: 'actionSelectCourse', text: '', align: 'end' },
      ]
      return headers
    },
    topFieldList() {
      const foundName = this.fieldList.findIndex(el => el.key === 'student_name')
      return this.fieldList.slice(0, foundName)
    },
    botFieldList() {
      const foundName = this.fieldList.findIndex(el => el.key === 'student_name')
      return this.fieldList.slice(foundName)
    },
    // custom options
    scoreOptions() {
      return this.$beltOptions || []
    },
    subjectOptions() {
      return this.$subjectOptions || []
    },
    // permission & setting
    canViewOrder() {
      return this.$validate.allowAction('OrderList', this.userType)
    },
    canViewAttendance() {
      return this.$validate.allowAction('StudentAttendance', this.userType)
    },
    canQuitAndRemission() {
      return this.$validate.allowAction('quitAndRemissStudent', this.userType)
    },
    canBlock() {
      return this.$validate.allowAction('blockStudent', this.userType)
    },
    canEdit() {
      return this.$validate.allowAction('editStudent', this.userType)
    },
    canDelete() {
      if (this.isAppMode(['T46']) && this.userType === 'admin') return false
      return this.canEdit && !this.isStudent
    },
    canViewLesson() {
      return this.$validate.allowAction('ClassDetails', this.userType)
    },
    canViewPointsRecord() {
      return (
        this.$validate.allowAction('StudentPoints', this.userType) ||
        this.$validate.allowAction('StudentUserPoints', this.userType)
      )
    },
    canViewPhone() {
      if (this.isAppMode(['T02'])) {
        return this.userType !== 'tutor'
      }
      return true
    },
    canViewLog() {
      return this.gEnableLog && this.$validate.allowAction('viewLog', this.userType)
    },
    // Hidden 學生詳情 - 成績
    disableScore() {
      return this.isAppMode(['T02', 'T11', 'T15', 'T16', 'T17', 'T18', 'T22', 'T27'])
    },
    usernameRequired() {
      return this.isAppMode(['T01']) || this.$validate.DataValid(this.id)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,

    userSelectedSchool: -1,
    id: null,
    disableCourseGrade: false,
    enableSign: false,
    count: 0,
    fieldList: [],
    fieldFormList: [],
    initFormData: {
      phone: '',
      username: '',
      student_code: '',
      gender: '',
    },
    formData: {
      age: '',
      login_block: false,
      avatar_list: [],
      student_code: '',
      school_id: null,
      schools: [],
      username: '',
      password: '',
      status: 'active',
      contact_person_1_name: '',
      contact_person_1_phone: '',
      contact_person_2_name: '',
      contact_person_2_phone: '',
      sign: '',

      // --- for T03
      contact_person_1_email: '',
      contact_person_2_email: '',
      contact_person_3_name: '',
      contact_person_3_phone: '',
      contact_person_3_email: '',
      // --- for T46
      contact_person_1_relationship: '',
      contact_person_2_relationship: '',
      // --- for T49
      referee_name: '',
      referee_phone: '',
    },
    wishLesson: '',
    tutorSchoolOptions: [],
    newPassword: '',
    confirmPassword: '',
    isNewPasswordEdit: false,

    scoreTableData: [],
    scoreTableLoading: false,
    performanceFormData: {
      grade: '',
      semester: '',
      subject: '',
      exam_name: '',
      score: '',
      update_date: '',
      show_public: true,
      file_list: [],
    },

    enablePoints: false,
    pointsCanUse: 0,

    studentNewsTableData: [],
    studentNewsData: {
      content: '',
    },

    existMonthPass: [],
    existMonthPassDates: [],
    isSearching: false,
    addCourseFilter: {
      keyword: '',
      dateRange: [],
      tutor: '', // tutor id
      grade: '',
      lessonRule: 'auto', // 'auto' | 'manually',
      limitOptions: [5, 10, 20],
      limit: vm.isAppMode(['T37']) ? 20 : 5,
      page: 1,
      total: 0,
      tableData: [],
      selectedRow: [],
    },
    courseNameSearching: false,
    courseNameOptions: [],
    tempSelectedLesson: [],
    tutorOptions: [],

    siblingTableData: [],
    siblingData: {
      student_id: null,
      relationship: null,
    },
    studentOptions: [],
    uplineStudentOptions: [],
    studentSearching: false,
    changeCenterAlert: {
      studentName: '',
      centerName: '',
      centerOptions: [],
      schoolId: null,
    },

    teamMemberTableData: [],
    teamMemberData: {
      student_id: null,
    },

    logLoading: false,
    logTableData: [],
    logTableTotal: 0,

    // --- Static data
    semesterOptions: [
      { value: 'upper', text: vm.$t('semesterOption.upper') },
      { value: 'lower', text: vm.$t('semesterOption.lower') },
    ],
    yesNoOptions: [
      { value: true, text: vm.$t('true') },
      { value: false, text: vm.$t('false') },
    ],
    siblingOptions: [
      { value: 'elder_brother', text: vm.$t('siblingOptions.elder_brother') },
      { value: 'younger_brother', text: vm.$t('siblingOptions.younger_brother') },
      { value: 'elder_sister', text: vm.$t('siblingOptions.elder_sister') },
      { value: 'younger_sister', text: vm.$t('siblingOptions.younger_sister') },
    ],
  }),
  methods: {
    async getStudentById() {
      this.scoreTableLoading = true

      try {
        const data = await this.$Fetcher.GetStudentById(this.id, {
          join_siblings: true,
          join_team_member: true,
        })

        // staff只可以view所屬分校student
        if (
          !this.isStudent &&
          !this.gDisableStudentCenter &&
          this.$validate.DataValid(data.schools, true) &&
          !data.schools.includes(-1)
        ) {
          let pass = false
          const getUserSchools = this.gfGetUserSchools()
          for (let i = 0; i < data.schools.length; i++) {
            if (getUserSchools.includes(data.schools[i])) {
              pass = true
              break
            }
          }

          if (!pass) {
            this.permissionValid = false
            throw 'message.notBelongStudentBranch'
          }
        }

        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
        for (const key in this.initFormData) {
          if (this.$validate.DataValid(data[key])) {
            this.initFormData[key] = data[key]
          }
        }
        this._getAge(this.formData.birthday)
        this.formData.avatar_list = []
        if (data['avatar']) {
          this.formData.avatar_list.push({ name: data['avatar'], file: data['avatar'] })
        }

        if (data.schools.includes(-1)) {
          for (let i = 0; i < this.tutorSchoolOptions.length; i++) {
            if (!this.formData.schools.includes(this.tutorSchoolOptions[i].value)) {
              this.formData.schools.push(this.tutorSchoolOptions[i].value)
            }
          }
        } else {
          let isAllSchool = true
          for (let i = 0; i < this.tutorSchoolOptions.length; i++) {
            if (this.tutorSchoolOptions[i].value !== -1) {
              const found = this.formData.schools.find(el => el === this.tutorSchoolOptions[i].value)
              if (!found) {
                isAllSchool = false
                break
              }
            }
          }
          if (isAllSchool) {
            this.formData.schools.push(-1)
          }
        }

        this.studentNewsTableData = data.student_news.map(item => {
          this.count += 1
          return {
            ...item,
            id: this.count,
          }
        })
        this.siblingTableData = data.siblings.map(item => {
          return {
            ...item,
            id: item.student_id,
          }
        })

        if (this.isAppMode(['T27'])) {
          this.teamMemberTableData = data.team_member_datas
          if (this.$validate.DataValid(data.upline_student_code)) {
            this.uplineStudentOptions = [{ value: data.upline_student_code, text: data.upline_student_code }]
          }
        }

        if (data.wish_lesson > -1) {
          await this._getWishLesson(data.wish_lesson)
        }

        this.$store.dispatch('toggleLoadingPage', false)
        let next = await this._getStudentScores()
        if (next) next = await this._getStudentMonthPass()
        if (next) this.getLogData()
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: err,
            returnLink: this.isStudent ? '' : 'StudentList',
            isError: true,
          })
        }

        this.$store.dispatch('toggleLoadingPage', false)
      }
    },
    async _getStudentScores() {
      this.scoreTableLoading = true
      this.scoreTableData = []
      try {
        let payload = {
          filter_item: [{ key: 'student_id', value: this.id }],
        }
        if (this.isStudent) {
          payload['filter_item'].push({ key: 'show_public', value: true })
        }
        const { data } = await this.$Fetcher.GetStudentScores(payload)
        this.scoreTableData = data.map(el => {
          let obj = { ...el }
          if (this.isAppMode(['T01'])) {
            obj.create_date = el.update_date
          }
          return obj
        })
        this.scoreTableLoading = false
      } catch (err) {
        this.scoreTableLoading = false
        if (err === 'abort') {
          return false
        }
      }

      return true
    },
    async _getWishLesson(lessonId) {
      try {
        const data = await this.$Fetcher.GetLessonById(lessonId)
        this.wishLesson = `${data.course_name} (${this.$d(this.$formatter.convertDate(data.date), 'weekday')} ${
          data.start_time
        } - ${data.end_time})`
      } catch (err) {
        this.$common.error(err)
        this.wishLesson = ''
      }
    },

    async searchUplineStudents(keyword) {
      if (!keyword) {
        this.uplineStudentOptions = []
        return
      }

      this.studentSearching = true
      try {
        const { data } = await this.$Fetcher.GetStudents({
          filter_item: [
            { key: 'status', value: 'active' },
            { key: 'student_code', value: keyword },
          ],
        })

        const filterData = data.filter(item => item.id !== this.id)
        this.uplineStudentOptions = filterData.map(item => {
          return {
            value: item.student_code,
            text: item.student_code,
          }
        })
      } catch {
        this.uplineStudentOptions = []
      } finally {
        this.studentSearching = false
      }
    },

    async _getSetting() {
      let data = null
      try {
        data = await this.$Fetcher.GetSetting()
        if (this.$validate.DataValid(this.id)) {
          if (this.gEnablePointSystem && data.points_enable) {
            this.enablePoints = true
            this.pointsCanUse = await this.$Fetcher.GetUserPoints(this.id)
          }
        }

        if (this.$validate.DataValid(data.student_field, true)) {
          this.fieldFormList = data.student_field.map(item => {
            let options = []
            if (item.field_type === 'dropdown') {
              options = item.options.map(opt => {
                return {
                  value: opt.option_value,
                  text: this.$i18n.locale === 'en' ? opt.option_name_en : opt.option_name_zh,
                }
              })
            }
            return {
              type: 'string',
              key: item.field_key,
              label: this.$i18n.locale === 'en' ? item.field_name_en : item.field_name_zh,
              is_select: item.field_type === 'dropdown',
              is_multiple: item.is_multiple,
              required: item.is_required,
              options: options,
            }
          })
        }

        if (data.application_sign_required) {
          this.enableSign = true
        }
      } catch (err) {
        this.$common.error(err)
      }

      this.disableCourseGrade = this.gfCheckDisabledCourseGrade(data)
    },
    async _getTutorSchoolOptions() {
      this.tutorSchoolOptions = []
      try {
        const { data } = await this.$Fetcher.GetSchools()
        this.tutorSchoolOptions = data.map(el => {
          return { value: el.id, text: el.name }
        })

        if (!this.isStudent) {
          const getUserSchools = this.gfGetUserSchools()
          // 不屬於staff的分校會disabled
          this.tutorSchoolOptions = this.tutorSchoolOptions.map(el => {
            return {
              ...el,
              disabled: !getUserSchools.includes(el.value),
            }
          })
        }

        if (this.gEnableStudentMultiCenter) {
          this.tutorSchoolOptions.unshift({ value: -1, text: this.$t('allCenters') })
        }
      } catch {}
    },

    _refreshPage() {
      for (const key in this.formData) {
        if (key === 'school_id') {
          this.formData[key] = null
        } else if (key === 'status') {
          this.formData[key] = 'active'
        } else if (key === 'avatar_list' || key === 'schools') {
          this.formData[key] = []
        } else if (key === 'wish_lesson') {
          this.formData[key] = -1
        } else if (key === 'login_block') {
          this.formData[key] = false
        } else {
          this.formData[key] = ''
        }
      }
      for (const key in this.initFormData) {
        this.formData[key] = ''
      }
      this.wishLesson = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.isNewPasswordEdit = false

      this.scoreTableData = []

      this.pointsCanUse = 0

      this.studentNewsTableData = []

      this.existMonthPass = []
      this.existMonthPassDates = []
      this.tutorOptions = []
      this.courseNameOptions = []

      this.siblingTableData = []

      this.uplineStudentOptions = []
    },

    // --- generate fields
    _getFields() {
      this._refreshPage()

      this.fieldList = []
      fields.forEach(item => {
        let show = true
        if (
          item.ignore ||
          (this.$validate.DataValid(item.modes, true) && !this.isAppMode(item.modes)) ||
          (this.$validate.DataValid(item.except_modes, true) && this.isAppMode(item.except_modes)) ||
          (item.key === 'grade' && this.gDisableStudentGrade) ||
          (item.key === 'remark' && this.isStudent) ||
          (item.key === 'phone' && !this.canViewPhone)
        ) {
          show = false
        }

        if (item.key === 'special_remind_des' || item.key === 'enroll_reason_other' || item.key === 'know_from_other') {
          item.required = true
        }
        if (show) {
          this.fieldList.push(item)

          if (item.type === 'boolean') {
            this.$set(this.formData, item.key, false)
          } else if (item.key === 'wish_lesson') {
            this.$set(this.formData, item.key, -1)
          } else {
            this.$set(this.formData, item.key, '')
          }
        }
      })

      this.fieldFormList.forEach(item => {
        if (item.is_select && item.is_multiple) {
          this.$set(this.formData, item.key, [])
        } else {
          this.$set(this.formData, item.key, '')
        }
      })
    },
    showField(key) {
      if (
        (key === 'special_remind_des' && this.formData.special_remind !== true) ||
        (key === 'enroll_reason_other' && this.formData.enroll_reason !== 'others') ||
        (key === 'know_from_other' && this.formData.know_from !== 'other')
      ) {
        return false
      }

      if (this.isAppMode(['T49']) && this.userType === 'tutor' && (key === 'phone' || key === 'address')) {
        return false
      }

      return true
    },
    getFieldCol(key) {
      let cols = {
        'col-12': true,
      }

      // sm
      switch (key) {
        case 'address':
          cols['col-sm-12'] = true
          break
        case 'is_membership':
        case 'agree_promo':
        case 'wish_lesson':
          cols['col-sm-12'] = true
          break
        default:
          cols['col-sm-6'] = true
          break
      }

      // md
      switch (key) {
        case 'address':
          cols['col-md-8'] = true
          break
        case 'special_remind':
        case 'is_membership':
        case 'agree_promo':
        case 'wish_lesson':
          cols['col-md-6'] = true
          break
        default:
          cols['col-md-4'] = true
          break
      }

      // lg
      switch (key) {
        case 'address':
          cols['col-lg-6'] = true
          break
        case 'special_remind':
        case 'is_membership':
        case 'agree_promo':
        case 'wish_lesson':
          cols['col-lg-4'] = true
          break
        default:
          cols['col-lg-3'] = true
          break
      }

      return cols
    },
    handleFieldInput(key, value) {
      if (key === 'phone') {
        this._handleStudentPhoneInput(value)
      }
    },
    _handleStudentPhoneInput(value) {
      if (this.id === null && !this.isNewPasswordEdit) {
        this.$set(this.formData, 'password', value)
      }
      if (this.isAppMode(['T37'])) {
        this.$set(this.formData, 'contact_person_1_phone', value)
      }
    },
    handleFieldChanged(key, value) {
      if (key === 'enroll_reason') {
        this.formData.enroll_reason_other = ''
      } else if (key === 'know_from') {
        this.formData.know_from_other = ''
      } else if (key === 'job_class' && this.isAppMode(['T27'])) {
        if (['ADM', 'DM', 'SDM', 'BM', 'SBM', 'DD', 'SDD', 'EDD'].includes(value)) {
          this.$set(this.formData, 'member_level', 'team_head')
        }
      }
    },
    handleFieldDateChanged(key, value) {
      if (key === 'birthday') {
        this._getAge(value)
      }
    },
    _getAge(value) {
      this.formData.age = ''
      if (this.$validate.DataValid(value) && this.$validate.regexDateStr(value)) {
        const birth = this.$formatter.convertDate(value)
        const today = this.$formatter.convertDate()
        let age = Math.abs(today.getFullYear() - birth.getFullYear())
        if (
          birth.getMonth() > today.getMonth() ||
          (birth.getMonth() === today.getMonth() && birth.getDate() > today.getDate())
        ) {
          age = age - 1
        }
        this.formData.age = age
      }
    },

    // -- (儲存)
    async save() {
      if (!this.$validate.DataValid(this.id) && this.isStudent) return
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)

      try {
        // ------------- payload -------------
        let payload = {
          student_code: this.formData.student_code || '',
          remark: this.formData.remark || '',
          student_name: this.formData.student_name || '',
          student_eng_name: this.formData.student_eng_name || '',
          grade: this.formData.grade || '',
          student_school_name: this.formData.student_school_name || '',
          phone: this.formData.phone || '',
          address: this.formData.address || '',
          birthday: (this.formData.birthday || '').replace(/\//g, '-'),
          gender: this.formData.gender || '',
          member_level: this.formData.member_level || '',
          username: this.formData.username || '',
          contact_person_1_name: this.formData.contact_person_1_name || '',
          contact_person_1_phone: this.formData.contact_person_1_phone || '',
          contact_person_2_name: this.formData.contact_person_2_name || '',
          contact_person_2_phone: this.formData.contact_person_2_phone || '',
          apply_date: (this.formData.apply_date || '').replace(/\//g, '-'),
          trial_date: (this.formData.trial_date || '').replace(/\//g, '-'),
          special: this.formData.special || '',
          admission_source: this.formData.admission_source || '',
          student_zh_name: this.formData.student_zh_name || '',
          avatar: this.formData.avatar_list.length ? this.formData.avatar_list[0].file : '',
        }
        if (!this.usernameRequired) {
          payload['generate_username'] = true
        }

        // center
        if (this.gEnableStudentMultiCenter) {
          if (this.formData.schools.includes(-1)) {
            payload['schools'] = [-1]
          } else {
            payload['schools'] = this.formData.schools
          }
          payload['school_id'] = -1
        } else {
          payload['schools'] = []
          payload['school_id'] = this.$validate.DataValid(this.formData.school_id) ? this.formData.school_id : -1
          if (payload['school_id'] > -1) {
            payload['schools'] = [payload['school_id']]
          }
        }

        let knowFrom = []
        if (this.formData.know_from) {
          if (this.formData.know_from === 'other') {
            knowFrom = [this.formData.know_from_other]
          } else {
            knowFrom = [this.formData.know_from]
          }
        }

        if (this.isAppMode(['T03'])) {
          payload['school_time'] = this.formData.school_time || ''
          payload['contact_person_1_email'] = this.formData.contact_person_1_email || ''
          payload['contact_person_2_email'] = this.formData.contact_person_2_email || ''
          payload['contact_person_3_name'] = this.formData.contact_person_3_name || ''
          payload['contact_person_3_phone'] = this.formData.contact_person_3_phone || ''
          payload['contact_person_3_email'] = this.formData.contact_person_3_email || ''
          payload['special_remind'] = this.formData.special_remind || false
          payload['special_remind_des'] = this.formData.special_remind_des || ''
          payload['agree_video'] = this.formData.agree_video || false
        } else if (this.isAppMode(['T11'])) {
          payload['enroll_reason'] = this.formData.enroll_reason || ''
          payload['enroll_reason_other'] = this.formData.enroll_reason_other || ''
          payload['school_type'] = this.formData.school_type || ''
          payload['nation'] = this.formData.nation || ''
          payload['is_membership'] = this.formData.is_membership || false
          payload['have_football_shirt'] = this.formData.have_football_shirt || false
          payload['have_participate_competition'] = this.formData.have_participate_competition || false
        } else if (this.isAppMode(['T17'])) {
          payload['credit_remark'] = this.formData.credit_remark || ''
        } else if (this.isAppMode(['T20'])) {
          payload['know_from'] = knowFrom
          payload['ever_enrolled'] = this.formData.ever_enrolled || false
          payload['location'] = this.formData.location || ''
        } else if (this.isAppMode(['T21'])) {
          payload['textbook'] = this.formData.textbook || ''
          payload['know_from'] = knowFrom
          payload['agree_promo'] = this.formData.agree_promo || false
          payload['student_news'] = this.studentNewsTableData.map(item => {
            return {
              date: item.date,
              content: item.content,
            }
          })
        } else if (this.isAppMode(['T27'])) {
          payload['belong'] = this.formData.belong || ''
          payload['job_class'] = this.formData.job_class || ''
          payload['join_newbie_passion'] = this.formData.join_newbie_passion || false
          payload['upline_student_code'] = this.formData.upline_student_code || ''
          payload['id_card_full_name'] = this.formData.id_card_full_name || ''
        } else if (this.isAppMode(['T30'])) {
          payload['class_format'] = this.formData.class_format || ''
        } else if (this.isAppMode(['T32'])) {
          payload['hkid'] = this.formData.hkid || ''
          payload['email'] = this.formData.email || ''
        } else if (this.isAppMode(['T40'])) {
          payload['email'] = this.formData.email || ''
          payload['parent_name'] = this.formData.parent_name || ''
          payload['child_1'] = this.formData.child_1 || ''
          payload['child_1_birth'] = this.formData.child_1_birth || ''
          payload['child_2'] = this.formData.child_2 || ''
          payload['child_2_birth'] = this.formData.child_2_birth || ''
          payload['child_3'] = this.formData.child_3 || ''
          payload['child_3_birth'] = this.formData.child_3_birth || ''
          payload['hkid'] = this.formData.hkid || ''
          payload['dap'] = this.formData.dap || ''
          payload['dob'] = this.formData.dob || ''
          payload['referee_name'] = this.formData.referee_name || ''
          payload['enrollment_date'] = this.formData.enrollment_date || ''
          payload['join_group'] = this.formData.join_group || ''
          payload['join_course'] = this.formData.join_course || false
          payload['send_leave_notify'] = this.formData.send_leave_notify || ''
        } else if (this.isAppMode(['T46'])) {
          payload['nickname'] = this.formData.nickname || ''
          payload['contact_person_1_relationship'] = this.formData.contact_person_1_relationship || ''
          payload['contact_person_2_relationship'] = this.formData.contact_person_2_relationship || ''
        } else if (this.isAppMode(['T49'])) {
          payload['referee_name'] = this.formData.referee_name || ''
          payload['referee_phone'] = this.formData.referee_phone || ''
          payload['email'] = this.formData.email || ''
        } else if (this.isAppMode(['T51'])) {
          payload['email'] = this.formData.email || ''
          payload['email_2'] = this.formData.email_2 || ''
          payload['preferred_school'] = this.formData.preferred_school || ''
          payload['award'] = this.formData.award || ''
        } else if (this.isAppMode(['T57'])) {
          payload['belong_family_member'] = this.formData.belong_family_member || ''
          payload['email'] = this.formData.email || ''
        } else if (this.isAppMode(['T59'])) {
          payload['weapon_hand'] = this.formData.weapon_hand || ''
          payload['join_date'] = this.formData.join_date || ''
        }

        for (let i = 0; i < this.fieldFormList.length; i++) {
          payload[this.fieldFormList[i].key] = this.formData[this.fieldFormList[i].key]
        }

        // password
        if (this.$validate.DataValid(this.id)) {
          if (payload['phone'] !== this.initFormData.phone) {
            payload['password'] = payload['phone']
          }
        } else {
          payload['password'] = this.formData.password
        }
        // --------- End of payload ----------

        let message = {}
        if (this.$validate.DataValid(this.id)) {
          await this.$Fetcher.UpdateStudent(this.id, payload)
          message = {
            message: 'message.saveSuccess',
            refresh: true,
          }
        } else {
          await this.$Fetcher.NewStudent(payload)
          message = {
            message: 'message.createSuccess',
            redirect: 'StudentList',
          }
        }

        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          ...message,
          type: 'success',
        })
      } catch (err) {
        this.showAlert({
          title: this.$validate.DataValid(this.id) ? 'message.saveFail' : 'message.createFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // -- (刪除)
    async handleDeleteStudent() {
      if (!this.canDelete || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmDeleteStudent',
        message: 'message.confirmDeleteStudentMsg',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.DeleteStudent(this.id)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'StudentList',
          })
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          if (err === 'message.quitUserRemoveLessonError') {
            this.showAlert({
              title: '',
              message: 'message.deleteUserRemoveLessonError',
              isError: true,
              returnLink: 'StudentList',
            })
          } else {
            this.showAlert({
              title: 'message.deleteFail',
              message: err,
              isError: true,
            })
          }
        }
      }
    },

    // -- (複製學生網址)
    copyStudentUrl() {
      const routes = this.$router.getRoutes()
      const foundLink = routes.find(el => el.name === 'StudentLogin')
      let prefix = 'student'
      if (foundLink && foundLink.meta && foundLink.meta.prefix) {
        prefix = foundLink.meta.prefix
      }
      this.gfCopyText(`${window.location.origin}/${prefix}-login/${this.initFormData.username}`)
    },

    // -- (查看電子簽名)
    viewImg(img) {
      this.$store.dispatch('openMediaPopup', { media: img })
    },

    // -- (學生退學)
    async handleStudentQuit() {
      if (!this.canQuitAndRemission || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }

      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ title: 'message.confirmQuit', message: 'message.confirmQuitMsg' })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.StudentQuit(this.id)
          this.formData.status = 'inactive'
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
        } catch (err) {
          if (err === 'message.quitUserRemoveLessonError') {
            this.formData.status = 'inactive'
          }
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },
    // -- (重新入學)
    async handleStudentRemission() {
      if (!this.canQuitAndRemission || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ message: 'message.confirmRemission' })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.StudentRemission(this.id)
          this.formData.status = 'active'
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // -- (限制登入)
    async handleBlockStudent() {
      if (!this.canBlock || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ message: 'message.confirmBlock' })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.BlockStudent(this.id)
          this.formData.login_block = true
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },
    // -- (解除登入限制)
    async handleRemoveBlock() {
      if (!this.canBlock || !this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ message: 'message.confirmRemoveBlock' })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.RemoveStudentBlock(this.id)
          this.formData.login_block = false
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ============ 重設密碼 ===========
    async handleChangePassword(newOpen = true) {
      if (newOpen) {
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        this.newPassword = ''
        this.confirmPassword = ''
        await this.$refs.passwordFormDialog.resetForm()
      } else {
        this.$refs.passwordFormDialog.setLoading(false)
      }

      const confirm = await this.$refs['passwordFormDialog'].show()
      if (confirm) {
        try {
          await this.$Fetcher.StudentChangePassword(this.id, this.newPassword)
          this.$store.dispatch('toggleSnack', {
            message: 'message.updateSuccess',
            type: 'success',
          })
          this.$refs.passwordFormDialog.hide()
        } catch (err) {
          this.showAlert({
            title: 'message.updateFail',
            message: err,
            isError: true,
          })
          this.handleChangePassword(false)
        }
      }
    },

    // ============ 新增成績 ===========
    async handleAddPerformance(id = null, newOpen = true) {
      if (newOpen) {
        if (this.isStudent) return
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }

        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        // -- reset form
        this.performanceFormData.grade = ''
        this.performanceFormData.semester = ''
        this.performanceFormData.subject = ''
        this.performanceFormData.exam_name = ''
        this.performanceFormData.score = ''
        const nowTime = await this.$XHR.serverTime()
        this.performanceFormData.update_date = nowTime.substring(0, 10)
        this.performanceFormData.show_public = true
        this.performanceFormData.file_list = []
        this.$refs.performanceDialog.setInfo(id)
        if (this.$validate.DataValid(id)) {
          const target = this.scoreTableData.find(el => el.id === id)
          if (target) {
            this.performanceFormData.grade = target.grade
            this.performanceFormData.semester = target.semester
            this.performanceFormData.subject = target.subject
            this.performanceFormData.exam_name = target.exam_name
            this.performanceFormData.score = target.score
            this.performanceFormData.update_date = target.update_date
            this.performanceFormData.show_public = target.show_public
            if (target.file) {
              this.performanceFormData.file_list.push({ file: target.file, name: target.file })
            }
          }
        }
      } else {
        this.$refs.performanceDialog.setLoading(false)
      }

      const confirm = await this.$refs.performanceDialog.show()
      if (confirm) {
        let payload = {
          student_id: this.id,
          exam_name: this.performanceFormData.exam_name,
          grade: this.performanceFormData.grade,
          semester: this.performanceFormData.semester,
          subject: this.performanceFormData.subject,
          score: this.performanceFormData.score,
          update_date: this.performanceFormData.update_date,
        }
        if (!this.isAppMode(['T01'])) {
          payload['show_public'] = this.performanceFormData.show_public
          payload['file'] = ''
          if (this.performanceFormData.file_list.length) {
            payload['file'] = this.performanceFormData.file_list[0].file
          }
        }
        try {
          if (this.$validate.DataValid(id)) {
            await this.$Fetcher.UpdateStudentScore(id, payload)
          } else {
            await this.$Fetcher.NewStudentScore(payload)
          }

          this.$store.dispatch('toggleSnack', {
            message: this.$validate.DataValid(id) ? 'message.updateSuccess' : 'message.createSuccess',
            type: 'success',
          })
          this.$refs.performanceDialog.hide()
          this.scoreTableLoading = true
          setTimeout(() => {
            this._getStudentScores()
          }, 1000)
        } catch (err) {
          this.showAlert({
            title: this.$validate.DataValid(id) ? 'message.updateFail' : 'message.createFail',
            message: err,
            isError: true,
          })
          this.handleAddPerformance(id, false)
        }
      }
    },
    checkIsEditPerformance() {
      if (this.$refs && this.$refs.performanceDialog) {
        const editId = this.$refs.performanceDialog.getInfo()
        return this.$validate.DataValid(editId)
      }

      return false
    },
    // -- (刪除)
    async handleDeletePerformance(id) {
      if (this.isStudent) return
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const confirm = await this.confirmRef.show({
        isDelete: true,
        enableShowRemindCheckbox: true,
        key: 'deletePerformance',
      })
      if (confirm) {
        const targetPos = this.scoreTableData.findIndex(el => el.id === id)
        if (targetPos > -1) {
          this.$store.dispatch('setLoading', true)
          try {
            await this.$Fetcher.DeleteStudentScore(id)
            this.$store.dispatch('toggleSnack', {
              message: 'message.deleteSuccess',
              type: 'success',
            })
            this.scoreTableData.splice(targetPos, 1)
          } catch (err) {
            this.showAlert({
              title: 'message.deleteFail',
              message: err,
              isError: true,
            })
          } finally {
            this.$store.dispatch('setLoading', false)
          }
        }
      }
    },

    previewFile(file) {
      if (!file) return
      const type = file.split('.').pop()
      if (['png', 'jpeg', 'jpg'].includes(type.toLowerCase())) {
        this.$store.dispatch('openMediaPopup', {
          media: `${this.$mediaPath}${file}`,
        })
      } else {
        window.open(`${this.$mediaPath}${file}`, '_blank')
      }
    },

    // ============ 學生消息 ============
    async handleAddStudentNews(id = null, newOpen = true) {
      if (newOpen) {
        if (this.isStudent) return
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        // -- reset form
        this.studentNewsData.content = ''
        if (this.$validate.DataValid(id)) {
          const target = this.studentNewsTableData.find(el => el.id === id)
          if (target) {
            this.studentNewsData.content = target.content
          }
        }
      } else {
        this.$refs.studentNewsDialog.setLoading(false)
      }

      const confirm = await this.$refs.studentNewsDialog.show()
      if (confirm) {
        let update = false
        if (this.$validate.DataValid(id)) {
          for (let i = 0; i < this.studentNewsTableData.length; i++) {
            if (this.studentNewsTableData[i].id === id) {
              if (this.studentNewsTableData[i].content !== this.studentNewsData.content) {
                this.studentNewsTableData[i].content = this.studentNewsData.content
                update = true
              }
              break
            }
          }
        } else {
          update = true
          this.count += 1
          const nowTime = await this.$XHR.serverTime()
          this.studentNewsTableData.unshift({
            id: this.count,
            date: nowTime,
            content: this.studentNewsData.content,
          })
        }

        if (update && this.dispatchUpdateOnChange === true) {
          this.$store.dispatch('setDataIsUpdated', true)
        }
        this.$refs.studentNewsDialog.hide()
      }
    },
    // -- (刪除)
    async handleDeleteStudentNews(id) {
      if (this.isStudent) return
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const targetPos = this.studentNewsTableData.findIndex(el => el.id === id)
      if (targetPos > -1) {
        this.studentNewsTableData.splice(targetPos, 1)
        if (this.dispatchUpdateOnChange === true) {
          this.$store.dispatch('setDataIsUpdated', true)
        }
      }
    },

    // ============= 兄弟姊妹 ===========
    async handleAddSibling(id = null, newOpen = true) {
      if (newOpen) {
        if (this.isStudent) return
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        this.siblingData.student_id = null
        this.siblingData.relationship = null
        this.studentSearching = false
        this.studentOptions = []
        if (this.$validate.DataValid(id)) {
          this.studentSearching = true
          const found = this.siblingTableData.find(el => el.id === id)
          try {
            const data = await this.$Fetcher.GetStudentById(found.student_id)
            this.studentOptions.push({ ...data, value: data.id, text: `${data.display_student_name} (${data.phone})` })
            this.onSiblingStudentChanged(data.id)
          } catch {
          } finally {
            this.studentSearching = false
            this.siblingData.student_id = found.student_id
            this.siblingData.relationship = found.relationship
          }
        } else {
          this.onSiblingStudentChanged()
        }
      } else {
        this.$refs.siblingFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.siblingFormDialog.show()
      if (confirm) {
        // check repeat
        const foundRepeat = this.siblingTableData.find(el => el.id === this.siblingData.student_id)
        if (foundRepeat) {
          if (!this.$validate.DataValid(id) || id !== foundRepeat.id) {
            this.showAlert({
              title: 'message.operationalError',
              message: 'message.siblingExist',
              isError: true,
            })
            this.handleAddSibling(id, false)
            return
          }
        }

        const payload = {
          siblings: this.siblingTableData.map(item => {
            return {
              student_id: item.student_id,
              relationship: item.relationship,
            }
          }),
          join_siblings: true,
        }
        if (this.$validate.DataValid(id)) {
          for (let i = 0; i < payload.siblings.length; i++) {
            if (payload.siblings[i].student_id === id) {
              payload.siblings[i].student_id = this.siblingData.student_id
              payload.siblings[i].relationship = this.siblingData.relationship
              break
            }
          }
        } else {
          payload.siblings.unshift({
            student_id: this.siblingData.student_id,
            relationship: this.siblingData.relationship,
          })
        }
        try {
          const data = await this.$Fetcher.UpdateStudent(this.id, payload)
          this.siblingTableData = data.siblings.map(item => {
            return {
              ...item,
              id: item.student_id,
            }
          })

          // sync relationship
          await this._syncStudentRelationship(this.siblingData.student_id, this.siblingData.relationship)
          this.$refs.siblingFormDialog.hide()
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.handleAddSibling(id, false)
        }
      }
    },
    async _syncStudentRelationship(siblingId, relationship) {
      try {
        const data = await this.$Fetcher.GetStudentById(siblingId)
        const obj = {
          student_id: this.id,
          relationship: '',
        }
        if (relationship === 'elder_brother' || relationship === 'elder_sister') {
          if (this.initFormData.gender === 'M') {
            obj.relationship = 'younger_brother'
          } else if (this.initFormData.gender === 'F') {
            obj.relationship = 'younger_sister'
          }
        } else if (relationship === 'younger_brother' || relationship === 'younger_sister') {
          if (this.initFormData.gender === 'M') {
            obj.relationship = 'elder_brother'
          } else if (this.initFormData.gender === 'F') {
            obj.relationship = 'elder_sister'
          }
        }

        const payload = {
          siblings: [...data.siblings],
        }
        const foundIndex = payload.siblings.findIndex(el => el.student_id === this.id)
        if (foundIndex > -1) {
          payload.siblings[foundIndex].relationship = obj.relationship
        } else {
          payload.siblings.unshift(obj)
        }

        await this.$Fetcher.UpdateStudent(siblingId, payload)
      } catch (err) {
        this.$common.error(err)
      }
    },

    async searchStudents(keyword) {
      if (!keyword) {
        this.studentOptions = []
        return
      }

      this.studentSearching = true
      try {
        const { data } = await this.$Fetcher.GetStudents({
          search: keyword,
          filter_item: [{ key: 'status', value: 'active' }],
        })

        const filterData = data.filter(item => item.id !== this.id)
        this.studentOptions = filterData.map(item => {
          return { ...item, value: item.id, text: `${item.display_student_name} (${item.phone})` }
        })
      } catch {
        this.studentOptions = []
      } finally {
        this.studentSearching = false
      }
    },
    onSiblingStudentChanged(id = null) {
      let siblings = ['elder_brother', 'elder_sister', 'younger_brother', 'younger_sister']
      if (this.$validate.DataValid(id)) {
        const found = this.studentOptions.find(el => el.value === id)
        if (found) {
          if (found.gender === 'M') {
            siblings = ['elder_brother', 'younger_brother']
          } else if (found.gender === 'F') {
            siblings = ['elder_sister', 'younger_sister']
          }
        }
      }

      this.siblingOptions = siblings.map(el => {
        return {
          value: el,
          text: this.$t(`siblingOptions.${el}`),
        }
      })
    },

    async navSibling(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (!this.gDisableStudentCenter) {
        try {
          const student = await this.$Fetcher.GetStudentById(id)
          if (
            this.userSelectedSchool > -1 &&
            student.schools.length > 0 &&
            !student.schools.includes(-1) &&
            !student.schools.includes(this.userSelectedSchool)
          ) {
            this.$store.dispatch('setLoading', true)
            this.changeCenterAlert.studentName = student.display_student_name
            if (student.schools.length === 1) {
              this.changeCenterAlert.centerName = await this._getCenterName(student.schools[0])
              this.$store.dispatch('setLoading', false)

              const confirm = await this.confirmRef.show({
                message: this.$t('message.confirmChangeCenter', {
                  name: this.changeCenterAlert.studentName,
                  center: this.changeCenterAlert.centerName,
                }),
              })
              if (confirm) {
                const adminSchools = this.gfGetUserSchools()
                if (!adminSchools.includes(student.schools[0])) {
                  this.showAlert({
                    title: '',
                    message: 'message.adminNotBelongsCenter',
                    isError: true,
                  })
                  return
                } else {
                  this.gfExpiredSettingLogo()
                  this.gfUpdateUserSelectedSchool(student.schools[0])
                }
              } else {
                return
              }
            } else {
              this.changeCenterAlert.centerOptions = []
              const centers = await this.$Fetcher.GetSchoolsByIdList(student.schools)
              for (let i = 0; i < student.schools.length; i++) {
                const found = centers.find(el => el.id === student.schools[i])
                if (found) {
                  this.changeCenterAlert.centerOptions.push({ value: student.schools[i], text: found.name })
                }
              }
              this._handleNavSchool(id)
              this.changeCenterAlert.schoolId = student.schools[0]
              this.$store.dispatch('setLoading', false)
              return
            }
          }
        } catch {}
      }

      this.$router.push({ name: 'StudentDetails', params: { id: id } })
    },
    async _handleNavSchool(studentId) {
      this.$refs.confirmChangeCenterMulti.setLoading(false)

      const confirm = await this.$refs.confirmChangeCenterMulti.show()
      if (confirm) {
        if (this.$validate.DataValid(this.changeCenterAlert.schoolId) && this.changeCenterAlert.schoolId > -1) {
          const adminSchools = this.gfGetUserSchools()
          if (!adminSchools.includes(this.changeCenterAlert.schoolId)) {
            this.showAlert({
              title: '',
              message: 'message.adminNotBelongsCenter',
              isError: true,
            })
            this._handleNavSchool(studentId)
            return
          } else {
            this.gfUpdateUserSelectedSchool(this.changeCenterAlert.schoolId)
          }
          this.$refs.confirmChangeCenterMulti.hide()
          this.gfExpiredSettingLogo()
          this.$router.push({ name: 'StudentDetails', params: { id: studentId } })
        } else {
          this.$refs.confirmChangeCenterMulti.hide()
        }
      }
    },
    async _getCenterName(school_id) {
      try {
        const data = await this.$Fetcher.GetSchoolById(school_id)
        return data.name
      } catch {
        return ''
      }
    },

    // -- (刪除)
    async handleDeleteSibling(id) {
      if (this.isStudent) return
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        isDelete: true,
        enableShowRemindCheckbox: true,
        key: 'deleteSibling',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        const payload = {
          siblings: this.siblingTableData.map(item => {
            return {
              student_id: item.student_id,
              relationship: item.relationship,
            }
          }),
          join_siblings: true,
        }
        payload['siblings'] = payload.siblings.filter(item => item.student_id !== id)
        try {
          const data = await this.$Fetcher.UpdateStudent(this.id, payload)
          this.siblingTableData = data.siblings.map(item => {
            return {
              ...item,
              id: item.student_id,
            }
          })

          // sync relationship
          await this._syncDeleteSibling(id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.$store.dispatch('setLoading', false)
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.$store.dispatch('setLoading', false)
        }
      }
    },
    async _syncDeleteSibling(siblingId) {
      const data = await this.$Fetcher.GetStudentById(siblingId)
      const payload = {
        siblings: [...data.siblings],
      }
      payload['siblings'] = payload.siblings.filter(item => item.student_id !== this.id)

      try {
        await this.$Fetcher.UpdateStudent(siblingId, payload)
      } catch (err) {
        this.$common.error(err)
      }
    },

    // ============== 組員 =============
    async handleAddTeamMember(newOpen = true) {
      if (newOpen) {
        if (this.isStudent) return
        if (!this.permissionValid) {
          this.$store.dispatch('toggleSnack', { message: 'noPermission' })
          return
        }
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        this.$refs.teamMemberFormDialog.resetForm()
        this.teamMemberData.student_id = null
        this.studentSearching = false
        this.studentOptions = []
      } else {
        this.$refs.teamMemberFormDialog.setLoading(false)
      }
      const confirm = await this.$refs.teamMemberFormDialog.show()
      if (confirm) {
        // check repeat
        const foundRepeat = this.teamMemberTableData.find(el => el.id === this.teamMemberData.student_id)
        if (foundRepeat) {
          this.showAlert({
            title: 'message.operationalError',
            message: 'message.teamMemberExist',
            isError: true,
          })
          this.handleAddTeamMember(false)
          return
        }

        try {
          const payload = {
            team_member: this.teamMemberTableData.map(item => item.id),
            join_team_member: true,
          }
          payload['team_member'].unshift(this.teamMemberData.student_id)

          const data = await this.$Fetcher.UpdateStudent(this.id, payload)
          this.teamMemberTableData = data.team_member_datas
          this.$refs.teamMemberFormDialog.hide()
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.handleAddTeamMember(false)
        }
      }
    },
    // -- (刪除)
    async handleDeleteTeamMember(id) {
      if (this.isStudent) return
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        isDelete: true,
        enableShowRemindCheckbox: true,
        key: 'deleteTeamMember',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        const payload = {
          team_member: this.teamMemberTableData.map(item => item.id),
          join_team_member: true,
        }
        payload['team_member'] = payload.team_member.filter(el => el !== id)

        try {
          const data = await this.$Fetcher.UpdateStudent(this.id, payload)
          this.teamMemberTableData = data.team_member_datas

          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.$store.dispatch('setLoading', false)
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ============== 月票 =============
    async _getStudentMonthPass() {
      this.existMonthPassDates = []
      this.existMonthPass = []
      try {
        const { data } = await this.$Fetcher.GetOrders({
          filter_item: [
            { key: 'student_id', value: this.id },
            { key: 'status', value: 'paid' },
          ],
        })

        const { list: existMonthPassList, dates } = this.gfGetUserMonthPass(data)
        this.existMonthPassDates = dates

        const today = this.$formatter.convertDate()
        for (let i = 0; i < existMonthPassList.length; i++) {
          // 攞未過期嘅月票
          for (let j = 0; j < existMonthPassList[i].dates.length; j++) {
            const startDate = this.$formatter.convertDate(existMonthPassList[i].dates[j].start_date)
            if (this.$validate.isDateEqual(startDate, today) || this.$validate.isDateGreater(startDate, today)) {
              this.existMonthPass.push(existMonthPassList[i].dates[j])
            }
          }
        }

        if (this.existMonthPassDates.length > 0 && this.existMonthPass.length < 1) {
          this.existMonthPass.push({
            start_date: this.existMonthPassDates[0],
            end_date: this.existMonthPassDates[this.existMonthPassDates.length - 1],
          })
        }
      } catch (err) {
        if (err === 'abort') {
          return false
        }
      }

      return true
    },
    formatMonthPassDate(date) {
      if (date) {
        return `${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`
      }

      return ''
    },

    async openAssignMonthPass() {
      if (this.isStudent) return
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }

      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.tempSelectedLesson = []
      this.addCourseFilter.dateRange = []
      this.addCourseFilter.keyword = ''
      this.addCourseFilter.tutor = ''
      this.addCourseFilter.grade = ''
      this.addCourseFilter.lessonRule = 'auto'
      this.addCourseFilter.page = 1
      this.addCourseFilter.total = 0
      this.addCourseFilter.tableData = []
      this.addCourseFilter.selectedRow = []

      if (this.existMonthPassDates.length) {
        this.addCourseFilter.dateRange = [
          this.existMonthPassDates[0],
          this.existMonthPassDates[this.existMonthPassDates.length - 1],
        ]
      }

      this.$refs.addCourseDialog.show('search_lesson')
      this.isSearching = true
      if (this.tutorOptions.length < 1) {
        await this._getTutorOptions()
      }
      this.searchCourses()

      if (this.courseNameOptions.length < 1 && !this.courseNameSearching) {
        this.courseNameSearching = true
        this.courseNameOptions = await this.$Fetcher.GetAllCourseNames(this.userSelectedSchool)
        this.courseNameSearching = false
      }
    },
    async _getTutorOptions() {
      try {
        let payload = {}
        if (this.userSelectedSchool > -1) {
          payload['center'] = [this.userSelectedSchool]
        }
        const { data } = await this.$Fetcher.GetStaffs(payload)
        this.tutorOptions = data.map(el => {
          return {
            value: el.id,
            text: el.name,
          }
        })
      } catch {}
    },

    onSelectLessonRuleChanged() {
      this.tempSelectedLesson = []
      this.addCourseFilter.selectedRow = []
    },
    onCourseFilterChange() {
      this.addCourseFilter.page = 1
      this.addCourseFilter.total = 0
      this.searchCourses()
    },
    async searchCourses() {
      this.isSearching = true
      this.addCourseFilter.tableData = []

      let payload = {
        controller_name: 'search_lesson',
        filter_page: this.addCourseFilter.page - 1,
        filter_limit: this.addCourseFilter.limit,
        join_tutor_data: true,
        filter_item: [{ key: 'start_date', value: this.$formatter.formatDate() }],
      }
      const selectedSchool = this.gfGetUserSelectedSchool()
      if (selectedSchool > -1) payload['center_id'] = selectedSchool

      if (this.$validate.DataValid(this.addCourseFilter.keyword)) {
        payload['filter_item'].push({ key: 'course_name', value: this.addCourseFilter.keyword })
      }

      if (this.$validate.DataValid(this.addCourseFilter.tutor) && this.addCourseFilter.tutor > -1) {
        payload['filter_item'].push({ key: 'staff_id', value: this.addCourseFilter.tutor })
      }

      if (this.$validate.DataValid(this.addCourseFilter.grade) && this.addCourseFilter.grade !== 'all') {
        payload['filter_item'].push({ key: 'grade', value: this.addCourseFilter.grade })
      }

      if (this.$validate.DataValid(this.addCourseFilter.dateRange) && this.addCourseFilter.dateRange.length) {
        if (this.addCourseFilter.dateRange[0]) {
          const foundPos = payload.filter_item.findIndex(el => el.key === 'start_date')
          if (this.addCourseFilter.dateRange.length > 1 && this.addCourseFilter.dateRange[1]) {
            payload['filter_item'][foundPos].value = this.addCourseFilter.dateRange[0]
            payload.filter_item.push({ key: 'end_date', value: this.addCourseFilter.dateRange[1] })
          } else {
            payload['filter_item'].splice(foundPos, 1)
            payload['filter_item'].push({ key: 'date', value: this.addCourseFilter.dateRange[0] })
          }
        }
      }

      try {
        const { data, total } = await this.$Fetcher.GetLessons(payload)
        this.addCourseFilter.total = total

        this.addCourseFilter.tableData = data.map(el => {
          return {
            id: el.id, // lesson id
            lesson_type: el.lesson_type,
            course_id: el.course_id,
            regular_id: el.regular_id,
            course_name: el.course_name,
            course_code: el.course_code,
            date: el.date,
            start_time: el.start_time,
            end_time: el.end_time,
            grade: el.grade,
            tutor: el.tutor_data_list.map(t => t.name).join(', '),
            current_student_num: el.current_student_num,
            max_student: el.max_student,
            unit_price: el.price,
            applied: el.student_ids.includes(this.id),
            disabled: !this.existMonthPassDates.includes(el.date),
          }
        })
      } catch (err) {
        this.$common.error(err)
        if (this.addCourseFilter.page === 1) {
          this.addCourseFilter.total = 0
        }
      } finally {
        this.isSearching = false
      }
    },
    handleAddCourseActionClick(action) {
      if (action === true) {
        this.handleAssignLessonConfirm()
      } else {
        this.$refs.addCourseDialog.hide(true)
      }
    },

    isItemSelected(id) {
      const found = this.addCourseFilter.selectedRow.find(elm => elm.id === id)
      return found ? true : false
    },

    // -- 報讀課程 (報名)
    async handleAssignLessonSelected(lesson_id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const targetLesson = this.addCourseFilter.tableData.find(el => el.id === lesson_id)
        const foundPos = this.addCourseFilter.selectedRow.findIndex(el => el.id === lesson_id)

        let selectedLessons = []
        if (this.addCourseFilter.lessonRule === 'manually') {
          // 手動選擇報讀課堂
          const foundTemp = this.tempSelectedLesson.findIndex(el => el.id === lesson_id)
          if (foundPos > -1) {
            this.addCourseFilter.selectedRow.splice(foundPos, 1)
            if (foundTemp > -1) {
              this.tempSelectedLesson.splice(foundTemp, 1)
            }
          } else {
            this.addCourseFilter.selectedRow.push(targetLesson)
            if (foundTemp < 0) {
              this.tempSelectedLesson.push(targetLesson)
            }
          }
          selectedLessons = [...this.tempSelectedLesson]
        } else {
          // 自動報讀
          if (foundPos > -1) {
            this.addCourseFilter.selectedRow.splice(foundPos, 1)

            for (let i = this.tempSelectedLesson.length - 1; i >= 0; i--) {
              if (this.tempSelectedLesson[i].course_code === targetLesson.course_code) {
                this.tempSelectedLesson.splice(i, 1)
              }
            }
          } else {
            const foundSameCourse = this.addCourseFilter.selectedRow.findIndex(
              el => el.course_code === targetLesson.course_code,
            )
            if (foundSameCourse > -1) {
              this.addCourseFilter.selectedRow.splice(foundSameCourse, 1)
            }
            this.addCourseFilter.selectedRow.push(targetLesson)
          }

          // 搵related lesson
          if (this.addCourseFilter.selectedRow.length) {
            this.addCourseFilter.selectedRow.sort((a, b) =>
              this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
            )

            const courseCodes = this.addCourseFilter.selectedRow.map(el => el.course_code)
            const minDate = this.$formatter.convertDate(this.addCourseFilter.selectedRow[0].date)
            minDate.setDate(minDate.getDate() - 1)
            const payload = {
              student_id: this.id,
              date: this.$formatter.formatDate(minDate),
              course_codes: courseCodes,
              selected_first_lessons: this.addCourseFilter.selectedRow.map(el => {
                return {
                  course_code: el.course_code,
                  date: el.date,
                  start_time: el.start_time,
                }
              }),
            }
            selectedLessons = await this.$Fetcher.GetPackageLessonsPreview(payload)
          }
        }

        selectedLessons = selectedLessons.filter(el => this.existMonthPassDates.includes(el.date))
        this.tempSelectedLesson = JSON.parse(JSON.stringify(selectedLessons))
        this.tempSelectedLesson.sort((a, b) =>
          this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
        )
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },
    // -- 報讀課程 (確認)
    async handleAssignLessonConfirm() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      // 如果冇揀到item，reject
      if (this.tempSelectedLesson.length < 1) {
        this.showAlert({
          title: 'message.operationalError',
          message: 'message.atLeastOneItem',
          isError: true,
        })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmAssignLesson',
        message: 'message.confirmAssignLessonMsg',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          const lessonIds = this.tempSelectedLesson.map(el => el.id)
          await this.$Fetcher.AddStudentToLessonWithMonthPass(this.id, lessonIds)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.$refs.addCourseDialog.hide()
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ========== Qr-code =========
    downloadQrCode() {
      const canvas = document.getElementById('qrCanvas').getElementsByTagName('canvas')
      if (canvas && canvas[0]) {
        try {
          const dataURL = canvas[0].toDataURL('image/png')
          const link = document.createElement('a')
          link.href = dataURL
          link.download = `${this.initFormData.student_code}.png`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } catch (err) {
          this.$common.error(err)
        }
      }
    },

    // ============== Log Record =============
    async getLogData() {
      if (this.canViewLog && this.$refs.logTableRef) {
        this.logLoading = true
        const filter = this.$refs.logTableRef.getFilter()
        try {
          const payload = {
            page: filter.page - 1,
            limit: filter.limit,
          }
          const { data, total } = await this.$Fetcher.GetStudentLogs(this.id, payload)
          this.logTableData = data
          this.logTableTotal = total
        } catch (err) {
          this.$common.error(err)
          this.logTableData = []
          if (filter.page === 1) {
            this.logTableTotal = 0
          }
        } finally {
          this.logLoading = false
        }
      }
    },

    async handleSiteLoaded() {
      if (this.isAppMode(['T03', 'T21'])) {
        this.enableSign = true
      }

      this.id = null
      if (this.routeId !== null) {
        this.id = this.routeId
      }

      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: StudentDetails')
      this.permissionValid = true
      this.userType = this.gfGetUserType()
      this.userSelectedSchool = this.gfGetUserSelectedSchool()
      if (this.isStudent) {
        const userData = this.gfGetCurrentUserData()
        this.id = userData.id
        if (!this.$route.params.username || this.$route.params.username !== userData.username) {
          this.$router.replace({ params: { username: userData.username } })
        }
      }

      await this._getSetting()
      this._getFields()

      await this._getTutorSchoolOptions()

      if (this.$validate.DataValid(this.id)) {
        await this.getStudentById()
      } else {
        // new
        this.formData.member_level = this.$memberOptions[0].value

        if (this.isStudent) {
          this.showAlert({
            message: 'noPermission',
          })
        } else {
          if (this.gEnableStudentMultiCenter) {
            // default 全部分校
            this.formData.schools = this.tutorSchoolOptions.map(el => el.value)
          } else {
            if (this.userSelectedSchool > -1) {
              this.formData.school_id = this.userSelectedSchool
            }
          }
        }
        this.$store.dispatch('toggleLoadingPage', false)
      }
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    this.logLoading = true
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>
